export const TEST_ID_CHECKED_ICON = 'ToggleSwitch_checked_icon';
export const TEST_ID_UNCHECKED_ICON = 'ToggleSwitch_unchecked_icon';
export const TEST_ID_OUTER_LABEL = 'ToggleSwitch_outer_label';
